/**
 * @ngdoc Service
 */
(function() {
    'use strict';

    angular.module('vrm.core')
        .service('RegistrationService', RegistrationService);

    /**
     * @constructor
     * @ngInject
     */
    function RegistrationService($log, ApiService, vrmNotificationsService, vrmNotificationType) {

        /* Public API */
        var service = {
            registrationModel: {
                name: null,
                email: null,
                phone: null,
                company: null,
                city: null,
                country: null,
                language: "en",
                dealer: null,
                password: null,
                password_confirm: null,
                invite_key: null,
                invite_type: 'site',
                recaptcha_response: null,
            },
            register: register
        };

        return service;

        /* Private */


        /**
         * Registration
         */
        function register() {

            return ApiService
                .call("/auth/register",service.registrationModel)
                .then(function(response) {
                    if (response.data.success) {
                        // promise accepted
                        return true;
                    } else {
                        // Add info about the Error
                        vrmNotificationsService.add({type: vrmNotificationType.DANGER, message: ApiService.formatErrors(response) + ' (1512)' }, true);

                        // reject this promise
                        return false;
                    }
                });
        }

    }
})();
